<template>
  <section>

    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="10000"
      multi-line
      left
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>

    <!-- DIALOGS START -->

    <v-dialog
      v-model="dialog.loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.delete"
      max-width="500"
      persistent
      v-if="dialog.hasLoaded"
    >
      <v-card>
        <v-card-title class="headline">You Sure, about deleting this Company?</v-card-title>

        <v-card-text>
          Are you sure, you want to delete this company? <br/> We suggest verifying the details before taking such an action.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            flat="flat"
            @click="() => {
              $router.push('/company/' + $route.params.id)
              dialog.delete = false
            }"
          >
            Don't Delete
          </v-btn>

          <v-btn
            color="error"
            flat="flat"
            @click="deleteCompany"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
        <v-dialog
      v-model="dialog.update"
      max-width="500"
      persistent
      v-if="dialog.hasLoaded"
    >
      <v-card>
        <v-card-title class="headline">Update this Company!</v-card-title>

        <v-card-text>
          <v-form v-model="valid">
            <div>
              <v-text-field label="NAME" :rules="nameRules" v-model="form.name" />
            </div>
            <div>
              <v-text-field label="LOGO" :rules="logoRules" v-model="form.logo" :required="false" />
            </div>
            <div>
              <v-text-field label="ADDRESS" :rules="addrRules" v-model="form.address" :required="false" />
            </div>
            <div>
              <v-text-field label="PHONE" :rules="phoneRules" v-model="form.phone" :required="false" />
            </div>
          </v-form>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            flat="flat"
            @click="() => {
              $router.push('/company/' + $route.params.id)
              dialog.update = false
            }"
          >
            Don't Update
          </v-btn>

          <v-btn
            color="error"
            flat="flat"
            :disabled="!valid"
            @click="updateCompany"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOGS END -->
    <v-container grid-list-md v-if="dialog.hasLoaded && !error">
      <v-layout row wrap>
        <v-flex sm12 md12 lg6>
          <v-card class="con--view-card">
            <div class="con--view-grid-basic">
              <div class="con--view-card-inner">
                <v-avatar size="200px">
                  <img :src="company.logo || 'https://lh4.googleusercontent.com/-03EW-FpeRBE/AAAAAAAAAAI/AAAAAAAAAAA/ZYNO4RH0oOo/s228-p/photo.jpg'" alt="">
                </v-avatar>
              </div>
              <div class="con--view-grid-basic-span-col-2">
                <div class="con--view-card-inner">
                  <p class="con--view-card-title" style="text-transform: capitalize;">{{company.name}}</p>
                  <p class="con--view-card-subtitle">ID# {{company.id}}</p>
                  <p class="con--view-card-subtitle">HQ: {{company.address || "NOT PROVIDED"}}</p>
                  <p class="con--view-card-subtitle">Phone: {{company.phone || "NOT PROVIDED"}}</p>
                </div>
              </div>
            </div>
          </v-card>
        </v-flex>
        <v-flex sm12 md12 lg6>
          <v-card class="con--view-card">
            <p class="con--view-title">Actions</p>
            <v-btn color="info" @click="moveTo(`/company/${company.id}?update=1`)">Update</v-btn>
            <v-btn color="error" @click="moveTo(`/company/${company.id}?delete=1`)">Delete</v-btn>
            <!-- <div class="con--view-grid-address">
              <div class="con--view-grid-address-span-4">
                <p class="con--view-detail-title">CONTACT OWNER</p>
                <p class="con--view-detail-subtitle">Lindsey Stirling</p>
              </div>
              <div>
                <p class="con--view-detail-title">ACCOUNT</p>
                <p class="con--view-detail-subtitle">Akshay</p>
              </div>
              <div>
                <p class="con--view-detail-title">REPORT TO</p>
                <p class="con--view-detail-subtitle">Daksh</p>
              </div>
              <div class="con--view-grid-address-span-2 text-sm-right">
                <v-btn depressed color="primary" to="/activities/create">Create Activity</v-btn>
              </div>
            </div> -->
          </v-card>
        </v-flex>
        <v-flex sm12 md12 lg12>
          <v-card class="con--view-card" style="overflow-y: scroll; max-height: 370px;">
            <p class="con--view-title">Users</p>
            <div v-if="loading_users">
              <h2 style="text-align: center; font-size: 40px;">Loading The Users.</h2>
            </div>
            <div v-if="!loading_users && users.length < 1">
              <h2 style="text-align: center; font-size: 40px;">No Users were found.</h2>
            </div>
            <v-list style="background: inherit;" v-if="!loading_users && users.length > 0">
              <v-list-tile
                v-for="(user, idx) in users"
                :key="user.id"
                avatar
                class="elevation-2"
                style="margin-bottom: 10px;"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ idx + 1 }}.
                    <router-link :to="`/user-accounts/${user.id}`">
                      {{ user.name }}
                    </router-link>
                    ({{ user.email}})
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex sm12 md12 lg12>
          <v-card class="con--view-card" style="max-height: 370px; overflow-y: scroll;">
            <p class="con--view-title">Entities</p>
            <div v-if="loading_entities">
              <h2 style="text-align: center; font-size: 40px;">Loading The Entities.</h2>
            </div>
            <div v-if="!loading_entities && entities.length < 1">
              <h2 style="text-align: center; font-size: 40px;">No Entities were found.</h2>
            </div>
            <v-list style="background: inherit;" v-if="!loading_entities && entities.length > 0">
              <v-list-tile
                v-for="(entity, idx) in entities"
                :key="entity.id"
                avatar
                class="elevation-2"
                style="margin-bottom: 10px;"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ idx + 1 }}.
                    <router-link :to="`/evoting/entity/${entity.id}`">
                      {{ entity.name }}
                    </router-link>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container v-if="error">
      <div>
        <v-alert
          :value="error"
          type="error"
        >
          {{ error.graphQLErrors.length > 0 ? error.graphQLErrors[0].message : error.message }}
        </v-alert>
      </div>

      <v-flex sm12 md12 lg12>
        <v-card class="con--view-card" style="min-height:150px;">
          <h2 style="text-align: center;">
            {{ error.graphQLErrors.length > 0 ? error.graphQLErrors[0].data.message : error.message }}
          </h2>

          <div style="text-align: center;">
            <v-btn color="primary" to="/company">Go back</v-btn>
          </div>
        </v-card>
      </v-flex>
    </v-container>

  </section>
</template>
<script>
import { coreClient } from "../../apollo";
import gql from "graphql-tag";
import checkPhone from "validator/lib/isMobilePhone";

export default {
  data() {
    return {
      company: {
        id: "",
        name: "",
        logo: "",
        address: "",
        phone: ""
      },
      dialog: {
        update: false,
        delete: false,
        hasLoaded: false,
        loading: false
      },
      snackbar: {
        show: false,
        text: "",
        color: ""
      },
      error: "",
      valid: false,
      form: {
        name: "",
        logo: "",
        address: "",
        phone: ""
      },
      nameRules: [
        v => !!v || "Name is required.",
        v => v.length > 1 || "Name must be more than a character."
      ],
      logoRules: [
        v =>
          v
            ? /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/.test(
                v
              ) || "Please enter a valid link."
            : true
      ],
      addrRules: [
        v =>
          v
            ? v.length > 5 || "Address must atleast be 5 characters long."
            : true
      ],
      phoneRules: [
        v => (v ? checkPhone(v) || "Phone No. must be valid." : true)
      ],
      loading_users: true,
      users: [],
      loading_entities: true,
      entities: []
    };
  },
  methods: {
    async getCompany(id) {
      this.dialog.loading = true;
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Company($id: String!) {
              Company(id: $id) {
                id
                name
                logo
                address
                phone
              }
            }
          `,
          variables: {
            id
          }
        });
        this.company = data.Company;
      } catch (e) {
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text: "We failed to find the Company.",
          color: "error"
        };
        this.error = e;
      }
      this.dialog.loading = false;
      this.dialog.hasLoaded = true;
    },
    moveTo(u) {
      this.$router.push(u);
      this.$router.go(u);
    },
    deleteCompany() {},
    async updateCompany() {
      let variables = {};
      Object.keys(this.form).forEach(field => {
        if (this.company[field] !== this.form[field]) {
          variables[field] = this.form[field];
        }
      });

      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation updateCompany(
              $id: String!
              $name: String
              $logo: String
              $address: String
              $phone: String
            ) {
              updateCompany(
                id: $id
                name: $name
                logo: $logo
                address: $address
                phone: $phone
              ) {
                id
                name
                logo
                address
                phone
              }
            }
          `,
          variables: {
            ...variables,
            id: this.company.id
          }
        });

        this.company = data.updateCompany;
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text: "The Company has been updated successfully.",
          color: "success"
        };
      } catch (e) {
        this.snackbar.show = false;
        this.snackbar = {
          show: true,
          text:
            e.graphQLErrors.length > 0
              ? e.graphQLErrors[0].data.message
              : e.message,
          color: "error"
        };
      }
      this.dialog.update = false;
    },
    async getUsers() {
      this.loading_users = true;
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Users($company: String!) {
              Users(company: $company) {
                docs {
                  id
                  name
                  email
                }
              }
            }
          `,
          variables: { company: this.$route.params.id }
        });

        this.users = data.Users.docs;
      } catch (e) {
        // ignore
      }
      this.loading_users = false;
    },
    async getEntities() {
      this.loading_entities = true;
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Entities($company: String!) {
              Entities(company: $company) {
                docs {
                  id
                  name
                }
              }
            }
          `,
          variables: {
            company: this.$route.params.id
          }
        });

        this.entities = data.Entities.docs;
      } catch (e) {
        // ignore
      }
      this.loading_entities = false;
    }
  },
  async mounted() {
    let { query } = this.$route;
    await this.getCompany(this.$route.params.id);
    await this.getUsers();
    await this.getEntities();

    if (query.update && query.delete) {
      // Uhmm, some error probably.
      return;
    }

    if (query.update) {
      // open the update prompt
      this.dialog.update = true;
      this.form = { ...this.company };
      return;
    }

    if (query.delete) {
      // open the delete prompt.
      this.dialog.delete = true;
      return;
    }

    return;
  }
};
</script>
<style lang="stylus" scoped>
@import '../../assets/stylus/Company_view.styl';
</style>
